import React from "react";
import { Box, Button, Container, Divider, Stack, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import { useNavigate } from "react-router-dom";
import logo from "../images/LogoNavbar1.svg";

const WHATSAPP_URL = "https://wa.me/message/HOYXZTTFNXNZH1";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <Box component="footer" sx={{ bgcolor: "#19242F", color: "#fff", pt: { xs: 6, md: 8 }, pb: 3 }}>
      <Container maxWidth="lg">
        <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", md: "center" }} spacing={4}>
          <Box sx={{ maxWidth: 520 }}>
            <Stack direction="row" alignItems="center" spacing={1.2}>
              <Box component="img" src={logo} alt="WebProfit" sx={{ width: 46, height: 46 }} />
              <Typography sx={{ fontWeight: 950, fontSize: "1.55rem", letterSpacing: "-.035em" }}>WebProfit</Typography>
            </Stack>
            <Typography sx={{ mt: 2, color: "rgba(255,255,255,.66)", lineHeight: 1.7 }}>
              Una plataforma para crear tu página, cargar lo que vendés y administrar el crecimiento de tu negocio desde un solo lugar.
            </Typography>
          </Box>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.3} sx={{ width: { xs: "100%", md: "auto" } }}>
            <Button onClick={() => navigate("/registro")} variant="contained" endIcon={<ArrowForwardRoundedIcon />} sx={{ minHeight: 50, px: 2.7, borderRadius: 999, bgcolor: "#F35A3A", textTransform: "none", fontWeight: 900, "&:hover": { bgcolor: "#DF4728" } }}>
              Crear página gratis
            </Button>
            <Button onClick={() => navigate("/login")} variant="outlined" startIcon={<LoginRoundedIcon />} sx={{ minHeight: 50, px: 2.4, borderRadius: 999, color: "#fff", borderColor: "rgba(255,255,255,.25)", textTransform: "none", fontWeight: 850, "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,.06)" } }}>
              Ingresar al panel
            </Button>
          </Stack>
        </Stack>

        <Divider sx={{ my: 4, borderColor: "rgba(255,255,255,.1)" }} />

        <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", md: "center" }} spacing={3}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: .4, sm: 2.5 }}>
            <Button onClick={() => navigate("/")} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start" }}>Inicio</Button>
            <Button onClick={() => navigate("/servicios")} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start" }}>Planes</Button>
            <Button onClick={() => navigate("/documentacion")} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start" }}>Documentación</Button>
            <Button onClick={() => (window.location.href = WHATSAPP_URL)} startIcon={<WhatsAppIcon />} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start" }}>Soporte por WhatsApp</Button>
          </Stack>
          <Typography sx={{ color: "rgba(255,255,255,.42)", fontSize: ".82rem" }}>
            © {new Date().getFullYear()} WebProfit. Todos los derechos reservados.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
